<template>
  <b-sidebar
    v-if="
      billInfoForCheckWarranty &&
      billInfoForCheckWarranty.billItems &&
      billInfoForCheckWarranty.billItems.length
    "
    id="sidebar-backdrop"
    :title="`Chọn sản phẩm của hóa đơn #${billInfoForCheckWarranty.billNumber} để bảo hành`"
    :backdrop-variant="variant"
    backdrop
    shadow
    :visible="value"
    @hidden="closeSidebar"
    width="45%"
  >
    <div class="px-5 py-2 my-3">
      <b-list-group>
        <b-list-group-item
          v-for="billItem in billInfoForCheckWarranty.billItems"
          :key="billItem.id"
          href="#"
          @click="selectProductWarranty(billItem)"
          tag="label"
        >
          <b-row>
            <b-col cols="1">
              <b-form-checkbox
                :checked="isItemSelected(billItem)"
                @change="toggleProductWarranty(billItem)"
              ></b-form-checkbox>
            </b-col>
            <b-col cols="8">
              <h5 class="mb-1">{{ billItem.productName }}</h5>
              <p
                class="mb-1 font-size-sm font-italic text-primary"
                v-if="billItem.imeiCode && billItem.imeiCode.trim()"
              >
                IMEI: {{ billItem.imeiCode }}
              </p>
            </b-col>
            <b-col
              cols="3"
              align-self="center"
              class="d-flex justify-content-end"
            >
              <b-badge
                variant="primary"
                class="rounded-pill ml-auto"
                v-show="billItem.warrantyMonthNo"
                >Số tháng bảo hành: {{ billItem.warrantyMonthNo }}</b-badge
              >
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </div>

    <template #footer>
      <b-row class="px-5 py-2">
        <b-col cols="6">
          <b-button block variant="outline-primary" @click="closeSidebar"
            >Hủy bỏ</b-button
          >
        </b-col>
        <b-col cols="6">
          <b-button block variant="primary" @click="navigateToWarrantyPage"
            >Tạo phiếu tiếp nhận bảo hành
            <b-badge
              variant="light"
              class="rounded ml-1"
              v-show="selectedProductWarrantyList.length"
              >{{ selectedProductWarrantyList.length }}</b-badge
            ></b-button
          >
        </b-col>
      </b-row>
    </template>
  </b-sidebar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { showConfirmNotify } from '@/utils/sweet-alert2';
import { PAGE_ACTION } from '@/utils/enum';

export default {
  name: 'BillListSelectWarrantyItemSideBar',
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'dark',
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      'billInfoForCheckWarranty',
      'selectedProductWarrantyList',
      'billWarrantyForCreate',
    ]),
  },
  watch: {
    billInfoForCheckWarranty: {
      handler(newVal) {
        if (
          newVal &&
          newVal.billItems &&
          newVal.billItems.length === 1 &&
          !this.isItemSelected(newVal.billItems[0])
        ) {
          // Tự động chọn item nếu chỉ có 1 item
          this.setSelectedBillWarrantyItem(newVal.billItems[0]);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      'fetchSalesReceiptForCheckWarranty',
      'setSelectedProductWarrantyList',
      'setSelectedBillWarrantyItem',
    ]),
    showConfirmNotify,
    closeSidebar() {
      this.setSelectedProductWarrantyList([]);
      this.$emit('input', false);
    },
    selectProductWarranty(product) {
      this.setSelectedBillWarrantyItem(product);
    },
    isItemSelected(billItem) {
      return this.selectedProductWarrantyList.some(
        (item) => item.id === billItem.id,
      );
    },
    toggleProductWarranty(billItem) {
      this.setSelectedBillWarrantyItem(billItem);
    },
    async navigateToWarrantyPage() {
      const content = {
        title: `Tạo phiếu tiếp nhận bảo hành cho hóa đơn #${this.billInfoForCheckWarranty.billNumber}`,
        text: `Bạn có chắc chắn tạo phiếu tiếp nhận bảo hành cho sản phẩm đã chọn?`,
        actionName: 'Xác nhận',
        confirmButtonColor: '#3699FF',
        position: 'top',
      };
      const result = await this.showConfirmNotify(content);
      if (!result.value) return;

      this.$router.push({
        name: 'warranty-reception-info',
        query: {
          billNumber: this.billInfoForCheckWarranty.billNumber,
          action: PAGE_ACTION.CREATE,
        },
      });
      this.closeSidebar();
    },
  },
};
</script>

<style></style>
